import { Flex as MantineFlex } from '@mantine/core'
import { FlexProps } from './flex.types'

export const Flex = ({ ...props }: FlexProps) => <MantineFlex {...props} />
